import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Loader2, Gift, Users, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import WaitlistCard from "@/components/WaitlistCard";

export default function Membership() {
  const navigate = useNavigate();
  const [m, setM] = useState(null);

  const loadData = async () => {
    try {
      const mem = await api.get("/membership");
      setM(mem.data);
    } catch { /* handled by guard */ }
  };
  useEffect(() => { loadData(); }, []);

  if (!m) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#D4AF37]" /></div>;

  const resetTime = m.ai?.reset_at ? new Date(m.ai.reset_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "midnight IST";

  return (
    <div className="mx-auto max-w-xl px-5 py-8" data-testid="membership-page">
      {/* Complimentary Early Access */}
      <div className="rounded-2xl border border-[#D4AF37]/40 bg-gradient-to-br from-[#1a1509] to-[#12100E] p-6" data-testid="early-access-card">
        <div className="flex items-center gap-2 text-[#D4AF37]"><Gift className="h-5 w-5" /> <span className="text-xs uppercase tracking-[0.2em]">Complimentary Early Access</span></div>
        <h1 className="mt-3 font-display text-3xl text-[#F4F1EA]">Complimentary Early Access</h1>
        <p className="mt-2 text-sm leading-relaxed text-[#C8C2B5]">
          Enjoy 20 AI messages and 10 new connections each day, on us, during Maziara's early-access period.
        </p>
        <div className="mt-5 grid grid-cols-2 gap-3">
          <div className="rounded-xl border border-[#2B241B] bg-[#0A0908] p-4" data-testid="allowance-ai">
            <MessageCircle className="h-4 w-4 text-[#D4AF37]" />
            <p className="mt-2 font-display text-2xl text-[#F4F1EA]">{m.ai?.remaining ?? 0}<span className="text-sm text-[#8C8578]">/{m.ai?.day_limit ?? 20}</span></p>
            <p className="text-xs text-[#8C8578]">AI messages left today</p>
          </div>
          <div className="rounded-xl border border-[#2B241B] bg-[#0A0908] p-4" data-testid="allowance-human">
            <Users className="h-4 w-4 text-[#D4AF37]" />
            <p className="mt-2 font-display text-2xl text-[#F4F1EA]">{m.human?.remaining ?? 0}<span className="text-sm text-[#8C8578]">/{m.human?.day_limit ?? 10}</span></p>
            <p className="text-xs text-[#8C8578]">New connections left today</p>
          </div>
        </div>
        <p className="mt-3 text-xs text-[#8C8578]">Allowances reset at midnight IST ({resetTime}).</p>
      </div>

      {/* Membership waitlist */}
      <div className="mt-6 rounded-2xl border border-[#2B241B] bg-[#12100E] p-6" data-testid="membership-waitlist-section">
        <h2 className="font-display text-2xl text-[#F4F1EA]">A more personal circle.</h2>
        <p className="mt-2 text-sm leading-relaxed text-[#C8C2B5]">
          Join the private membership waitlist for priority consideration when Maziara membership opens.
        </p>
        <WaitlistCard joined={m.waitlist_joined} onJoined={loadData} />
        <p className="mt-3 text-xs text-[#8C8578]">Early access is complimentary. Future membership invitations will be released in stages.</p>
      </div>

      <button onClick={() => navigate(-1)} className="mt-6 text-sm text-[#8C8578] hover:text-[#D4AF37]">Back</button>
    </div>
  );
}
